module.exports = __webpack_public_path__ + "static/media/new-paramount-logo.f2b113fb.svg";